import { useCallback } from 'react';

import { useDialogContext } from 'pages/ParentHelper/providers/DialogProvider/hooks';
import { useParentHelperContext } from 'pages/ParentHelper/providers/ParentHelperProvider/hooks';

import type { ChatId } from 'pages/ParentHelper/types';

export const useWrapperClick = (chatId: ChatId) => {
  const { chatId: selectedChatId, setChatId } = useParentHelperContext();
  const { open: openHistoryDialog, onClose: onCloseHistoryDialog } =
    useDialogContext();

  return useCallback(() => {
    if (selectedChatId !== chatId) {
      setChatId(chatId);
    }

    if (openHistoryDialog) {
      onCloseHistoryDialog();
    }
  }, [
    chatId,
    onCloseHistoryDialog,
    openHistoryDialog,
    selectedChatId,
    setChatId,
  ]);
};
